import { Locale } from "@hermes/locale";

/**
 * @returns the product link to go to the product page from grid
 */
export const generateLocalizedHref = (url: string, locale: Locale): string => {
    // all product item url must end end with a '/'
    const end = url?.endsWith("/") ? "" : "/";
    // we want the full url with base href (/xx/yy/product/*) all the time.
    return `${locale.urlPrefix}${url}${end}`;
};

export const formatAssetUrl = (url: string): string => url.replace(/\s/g, "");
